"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionCustomBlock = void 0;
var md_utils_1 = require("./md-utils");
// ref: https://github.com/posva/markdown-it-custom-block
// e.g.
// @[youtube](youtube-video-id)
exports.optionCustomBlock = {
    youtube: function (videoId) {
        if (!(videoId === null || videoId === void 0 ? void 0 : videoId.match(/^[a-zA-Z0-9_-]+$/))) {
            return "YouTubeのvideoIDが不正です";
        }
        var escapedVideoId = md_utils_1.escapeHtml(videoId);
        return "<div class=\"embed-youtube\"><iframe src=\"https://www.youtube.com/embed/" + escapedVideoId + "?loop=1&playlist=" + escapedVideoId + "\" allowfullscreen loading=\"lazy\"></iframe></div>";
    },
    slideshare: function (key) {
        if (!(key === null || key === void 0 ? void 0 : key.match(/^[a-zA-Z0-9_-]+$/))) {
            return "Slide Shareのkeyが不正です";
        }
        return "<div class=\"embed-slideshare\"><iframe src=\"https://www.slideshare.net/slideshow/embed_code/key/" + md_utils_1.escapeHtml(key) + "\" scrolling=\"no\" allowfullscreen loading=\"lazy\"></iframe></div>";
    },
    speakerdeck: function (key) {
        if (!(key === null || key === void 0 ? void 0 : key.match(/^[a-zA-Z0-9_-]+$/))) {
            return "Speaker Deckのkeyが不正です";
        }
        return "<div class=\"embed-speakerdeck\"><iframe src=\"https://speakerdeck.com/player/" + md_utils_1.escapeHtml(key) + "\" scrolling=\"no\" allowfullscreen allow=\"encrypted-media\" loading=\"lazy\"></iframe></div>";
    },
    jsfiddle: function (str) {
        if (!(str === null || str === void 0 ? void 0 : str.match(/^(http|https):\/\/jsfiddle\.net\/[a-zA-Z0-9_,\/\-]+$/))) {
            return "jsfiddleのURLが不正です";
        }
        // URLを~/embedded/とする
        // ※ すでにembeddedもしくはembedが含まれるURLが入力されている場合は、そのままURLを使用する。
        var url = str;
        if (!url.includes("embed")) {
            url = url.endsWith("/") ? url + "embedded/" : url + "/embedded/";
        }
        return "<div class=\"embed-jsfiddle\"><iframe src=\"" + url + "\" scrolling=\"no\" frameborder=\"no\" allowfullscreen allowtransparency=\"true\" loading=\"lazy\"></iframe></div>";
    },
    codepen: function (str) {
        if (!(str === null || str === void 0 ? void 0 : str.match(/^https:\/\/codepen\.io\/[a-zA-Z0-9]/))) {
            return "CodePenのURLが不正です";
        }
        var url = new URL(str.replace("/pen/", "/embed/"));
        url.searchParams.set("embed-version", "2");
        return "<div class=\"embed-codepen\"><iframe src=\"" + url + "\" scrolling=\"no\" scrolling=\"no\" frameborder=\"no\" allowtransparency=\"true\" loading=\"lazy\"></iframe></div>";
    },
    codesandbox: function (str) {
        if (!/^https:\/\/codesandbox\.io\/embed\/[a-zA-Z0-9\-_/.@?&=%]+$/.test(str)) {
            return "「https://codesandbox.io/embed/」から始まる正しいURLを入力してください";
        }
        return "<div class=\"embed-codesandbox\"><iframe src=\"" + str + "\" style=\"width:100%;height:500px;border:none;overflow:hidden;\" allow=\"accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking\" loading=\"lazy\" sandbox=\"allow-modals allow-forms allow-popups allow-scripts allow-same-origin\"></iframe></div>";
    },
    stackblitz: function (str) {
        if (!/^https:\/\/stackblitz\.com\/[a-zA-Z0-9\-_/.@?&=%]+$/.test(str)) {
            return "StackBlitzのembed用のURLを指定してください";
        }
        return "<div class=\"embed-stackblitz\"><iframe src=\"" + str + "\" scrolling=\"no\" frameborder=\"no\" allowtransparency=\"true\" loading=\"lazy\" allowfullscreen></iframe></div>";
    },
    // クライアントでhttps://platform.twitter.com/widgets.jsを読み込む必要あり
    tweet: function (str) {
        if (!(str === null || str === void 0 ? void 0 : str.match(/^https:\/\/twitter\.com\/[a-zA-Z0-9\_\-\/]+$/))) {
            return "ツイートページのURLを指定してください";
        }
        return "<div class=\"embed-tweet tweet-container\"><blockquote class=\"twitter-tweet\"><a href=\"" + str + "\"></a></blockquote></div>";
    },
};
